import React from 'react';
import {useThemeContext} from "@view/theme/context/hooks/useThemeContext";
import ThemeSizeSwitch from "@view/theme/toggleThemeMode/ThemeSizeSwitch";
import {saveThemeSize} from "@view/theme/helpers";
import {saveUiSettings} from "@view/theme/api/uiSettings";

const ToggleThemeSize = () => {
    const {
        themeSize,
        setThemeSize,
    } = useThemeContext()

    const onChange = () => {
        const newtThemeSize = themeSize === 'large' ? 'small' : 'large'
        setThemeSize(newtThemeSize)
        saveThemeSize(newtThemeSize)
        saveUiSettings({themeSize: newtThemeSize})
    }
    return (
        <ThemeSizeSwitch
            checked={themeSize === 'large'}
            onChange={onChange}
        />
    );
};

export default ToggleThemeSize;